import React from 'react';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import App from './App';
import './index.css';
import { Logger } from './utils/logger';
import { webConfig } from './utils/webConfig';
import TagManager from 'react-gtm-module';
import { logInfo } from './utils/logError';
import { ReportHandler } from 'web-vitals';
import ErrorBoundary from './utils/Errors';
import { serviceWorkerUnregister } from './serviceWorkerRegistration';
import { StyledEngineProvider } from '@mui/material/styles';
import { FingerprintProvider } from '@fingerprint/react';
import FingerprintBootstrap from './components/FingerprintBootstrap';
import clevertap from 'clevertap-web-sdk';
import { HelmetProvider } from 'react-helmet-async';

const initClevertap = async (clevertapAccountId: string | undefined) => {
    if (!clevertapAccountId) {
        console.log('Clevertap not initialized');
        return;
    }
    clevertap.privacy.push({ optOut: false });
    clevertap.privacy.push({ useIP: false });
    clevertap.init(clevertapAccountId);
    clevertap.spa = true;
};

// eslint-disable-next-line
console.log(
    '%cStop!',
    'color: #ff0000; font-size: 50px; font-weight: bold; text-shadow: 1px 1px 1px #000;',
);
// eslint-disable-next-line
console.log(
    '%cThis is a browser feature intended for developers. If someone told you to copy-paste something here to enable a "Hack", it is a scam and will give them access to your account.',
    'font-size: 20px; font-weight: bold; text-shadow: 0 0 0 #000;',
);

if (webConfig.isProduction) {
    Logger.configure({
        service: 'online-giving',
        logUnhandledExceptions: true,
        userType: Logger.UserType.DONOR,
    });
}

if (!webConfig.isPrerenderBot) {
    initClevertap(webConfig.clevertapAccountId);
}

webConfig.googleTagManagerId &&
    TagManager.initialize({
        gtmId: webConfig.googleTagManagerId,
        dataLayer: {
            dataLayerName: 'Online-Giving',
        },
    });

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement,
);
root.render(
    <React.StrictMode>
        <HelmetProvider>
            <StyledEngineProvider injectFirst>
                <Logger.BasicErrorBoundary fallback={<ErrorBoundary />}>
                    {webConfig.fingerprintPublicKey ? (
                        <Logger.BasicErrorBoundary fallback={<App />}>
                            <FingerprintProvider
                                apiKey={webConfig.fingerprintPublicKey}
                            >
                                <FingerprintBootstrap />
                                <App />
                            </FingerprintProvider>
                        </Logger.BasicErrorBoundary>
                    ) : (
                        <App />
                    )}
                </Logger.BasicErrorBoundary>
            </StyledEngineProvider>
        </HelmetProvider>
    </React.StrictMode>,
);

const reportHandler: ReportHandler = (metric) => {
    logInfo('Logging Metric', metric);
};

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(reportHandler);

serviceWorkerUnregister();
